const DEFAULT_COUNTRY = 'us';
const DEFAULT_LANGUAGE = 'en';
const DEFAULT_SEGMENT = 'dhs';
const DEFAULT_PAGE_TAG = 'pmc_signup';

const sanitizeFragment = (value) => {
    if (!value) {
        return DEFAULT_PAGE_TAG;
    }
    return value
        .toLowerCase()
        .replace(/[^a-z0-9]+/gi, '_')
        .replace(/^_+|_+$/g, '')
        .substring(0, 80) || DEFAULT_PAGE_TAG;
};

const getCookie = (name) => {
    const cookieSource = typeof document !== 'undefined' ? document.cookie : '';
    if (!cookieSource) {
        return '';
    }

    const cookie = cookieSource
        .split(';')
        .map((item) => item.trim())
        .find((item) => item.startsWith(`${name}=`));

    return cookie ? decodeURIComponent(cookie.split('=').slice(1).join('=')) : '';
};

const deriveQueryValue = (params, key, fallback, maxLength) => {
    const raw = params.get(key);
    if (!raw) {
        return fallback;
    }

    const normalized = raw.trim().toLowerCase();
    if (normalized === 'null' || (maxLength && normalized.length > maxLength)) {
        return fallback;
    }

    return normalized;
};

const deriveRequestSource = (params) => {
    const source = params.get('ref') || DEFAULT_PAGE_TAG;
    return sanitizeFragment(source);
};

const buildPageTag = (segment, requestSource) => {
    return sanitizeFragment(`${segment}_${requestSource}`);
};

const buildPageName = (country, language, segment) => `${country}:${language}:${segment}:pmc:pmcSignup`;

const ensureDellMetricsShape = () => {
    const dellGlobal = window.Dell || {};
    dellGlobal.Metrics = dellGlobal.Metrics || {};
    dellGlobal.Metrics.sc = dellGlobal.Metrics.sc || {};
    window.Dell = dellGlobal;
    return dellGlobal.Metrics.sc;
};

const sendMpulseDimensions = (sc) => {
    if (!window.BOOMR || typeof window.BOOMR.addVar !== 'function') {
        return false;
    }

    const vars = {
        __CustomerSet: sc.customerset,
        __PageTag: sc.pagetag,
        __RequestSource: sc.requestsource,
        __PrincipalID: sc.principalid || '',
        __cmpConsent: sc.cmpConsent || '',
        __AppId: sc.applicationname || '',
        DellCEMSession: getCookie('DellCEMSession'),
    };

    window.BOOMR.addVar(vars);
    return true;
};

const waitForMpulse = (sc, attempts = 20) => {
    if (sendMpulseDimensions(sc) || attempts <= 0) {
        return;
    }

    setTimeout(() => waitForMpulse(sc, attempts - 1), 250);
};

export const initDellMetrics = () => {
    if (typeof window === 'undefined') {
        return;
    }

    const params = new URLSearchParams(window.location.search);
    const country = deriveQueryValue(params, 'c', DEFAULT_COUNTRY, 2);
    const language = deriveQueryValue(params, 'l', DEFAULT_LANGUAGE, 2);
    const segment = deriveQueryValue(params, 's', DEFAULT_SEGMENT, 3);
    const requestSource = deriveRequestSource(params);

    const sc = ensureDellMetricsShape();
    sc.country = country;
    sc.language = language;
    sc.segment = segment;
    sc.customerset = sc.customerset || '19';
    sc.cms = sc.cms || 'pmc';
    sc.module = sc.module || DEFAULT_PAGE_TAG;
    sc.requestsource = requestSource;
    sc.pagetag = buildPageTag(segment, requestSource);
    sc.pagename = sc.pagename || buildPageName(country, language, segment);
    sc.applicationname = sc.applicationname || 'Transactional:PMC_Email_Sign_Up';
    sc.principalid = sc.principalid || '';
    sc.cmpConsent = getCookie('dell_cmp_consent') || sc.cmpConsent || '';

    waitForMpulse(sc);
};
